import { ClientIntakeMessageMode } from "@sp-crm/core";

export type ClientEmailAudience = "client" | "communities";

export interface ClientEmailVariant {
    mode: ClientIntakeMessageMode;
    audience: ClientEmailAudience;
}

export function emailDialogHeaderText(
    variant: ClientEmailVariant,
    clientName: string,
): string {
    if (variant.mode === "notify") {
        return `Notify Unselected Communities for ${clientName}`;
    }

    return variant.audience === "client"
        ? `Email ${clientName}`
        : `Email Client Info for ${clientName}`;
}

export function offersIntakeAttachment(variant: ClientEmailVariant): boolean {
    return variant.mode === "intake" && variant.audience === "communities";
}
